<div class="product-integrations-container">
  <ng-container *ngIf="isLoading === true">
    <nz-skeleton [nzActive]="true"></nz-skeleton>
  </ng-container>
  <ng-container *ngIf="isLoading === false">
    <nz-list>
      <nz-list-item
        *ngFor="let integration of integrations"
        style="width: 100%"
      >
        <nz-list style="width: 100%">
          <nz-list-header *ngIf="integrations.length > 1">{{
            integration.Description
          }}</nz-list-header>
          <nz-list-item *ngFor="let channel of integration.Channels">
            <label
              nz-checkbox
              [nzChecked]="selectedChannels.has(channel)"
              (nzCheckedChange)="onSelectionChanged($event, channel)"
              >{{ channel.ChannelDescription }}</label
            >
          </nz-list-item>
        </nz-list>
      </nz-list-item>
    </nz-list>
  </ng-container>
</div>
